// Podgląd planu PDF: dopasowanie do ekranu, przybliżanie dwoma palcami / kółkiem, przesuwanie, ostrzejsze odrysowanie po geście.
// pdf.js ładuje się dopiero przy pierwszym otwarciu planu, żeby start aplikacji był szybki. Limit płótna 16 mln pikseli (iPhone).
const LIMIT_PIKSELI = 16_000_000;
// jedna obietnica na całe ładowanie: drugie wywołanie w trakcie ładowania czeka na ustawienie workera (losowy użytkownik 13.10: „No workerSrc specified”)
let ladowanie;
function biblioteka() {
  ladowanie ||= (async () => {
    const lib = await import('pdfjs-dist');
    lib.GlobalWorkerOptions.workerSrc = (await import('pdfjs-dist/build/pdf.worker.min.mjs?url')).default;
    return lib;
  })();
  return ladowanie;
}

/** Liczba stron i wymiary pierwszej strony (do zapisu przy wgrywaniu). */
export async function opisPdf(blob) {
  const lib = await biblioteka();
  const doc = await lib.getDocument({ data: new Uint8Array(await blob.arrayBuffer()) }).promise;
  const s = await doc.getPage(1); const v = s.getViewport({ scale: 1 });
  const wynik = { stron: doc.numPages, szer: v.width, wys: v.height };
  await doc.destroy();
  return wynik;
}

/** Otwiera plan w kontenerze. Zwraca obiekt z metodą zamknij() i stanem do testów. */
// Opcjonalnie warstwa ekranu (nakladkaEkranu): rysowana od razu przy każdym ruchu, bez ponownego odrysowania PDF (np. rogi obrysu),
// oraz chwytanie elementu tej warstwy jednym palcem (chwyc → przesun → pusc) zamiast przesuwania planu.
export async function pokazPlan(kontener, blob, { strona = 1, nakladka = null, naDotkniecie = null, nakladkaEkranu = null, chwyc = null, przesun = null, pusc = null } = {}) {
  const lib = await biblioteka();
  const doc = await lib.getDocument({ data: new Uint8Array(await blob.arrayBuffer()) }).promise;
  const page = await doc.getPage(strona);
  const v1 = page.getViewport({ scale: 1 });
  kontener.innerHTML = '<div class="plan-ramka"><canvas role="img" aria-label="Plan"></canvas><canvas class="plan-ekran" aria-hidden="true"></canvas></div><div class="plan-narzedzia"><button data-z="-" aria-label="Pomniejsz">−</button><button data-z="0">Dopasuj</button><button data-z="+" aria-label="Powiększ">＋</button></div>';
  const ramka = kontener.querySelector('.plan-ramka'), canvas = kontener.querySelector('canvas'), ekran = kontener.querySelector('.plan-ekran');
  // warstwa ekranu w pikselach ramki: punkt PDF (x, y) → piksel ramki
  const doEkranu = (x, y) => { const k = S.bazowa * S.skala; return [S.x + x * k, S.y + y * k]; };
  function rysujEkran() {
    if (!nakladkaEkranu) return; const r = ramka.getBoundingClientRect(); const dpr = window.devicePixelRatio || 1;
    const w = Math.max(1, Math.round(r.width * dpr)), h = Math.max(1, Math.round(r.height * dpr));
    if (ekran.width !== w || ekran.height !== h) { ekran.width = w; ekran.height = h; ekran.style.width = `${r.width}px`; ekran.style.height = `${r.height}px`; }
    const c = ekran.getContext('2d'); c.setTransform(dpr, 0, 0, dpr, 0, 0); c.clearRect(0, 0, r.width, r.height); nakladkaEkranu(c, doEkranu);
  }
  const S = { skala: 1, x: 0, y: 0, rysowania: 0, pdfWidth: v1.width, pdfHeight: v1.height };
  const dopasuj = () => { const r = ramka.getBoundingClientRect(); S.bazowa = Math.min(r.width / v1.width, r.height / v1.height); S.skala = 1; S.x = (r.width - v1.width * S.bazowa) / 2; S.y = (r.height - v1.height * S.bazowa) / 2; };
  let zadanie = null, timer = null;
  async function rysuj() {
    const dpr = window.devicePixelRatio || 1;
    let sk = S.bazowa * S.skala * dpr;
    const piks = v1.width * v1.height * sk * sk;
    if (piks > LIMIT_PIKSELI) sk *= Math.sqrt(LIMIT_PIKSELI / piks);
    const vp = page.getViewport({ scale: sk });
    if (zadanie) zadanie.cancel();
    const off = document.createElement('canvas'); off.width = Math.floor(vp.width); off.height = Math.floor(vp.height);
    // ramka o zerowym rozmiarze (widok już zamknięty albo jeszcze nie ułożony): nic nie rysujemy (błąd złapany przez losowego użytkownika 12.10)
    if (!(off.width >= 1 && off.height >= 1)) return;
    zadanie = page.render({ canvasContext: off.getContext('2d'), viewport: vp });
    try { await zadanie.promise; } catch { return; }
    // nakładka (np. pomieszczenia ze stanem prac) rysowana w układzie PDF przemnożonym przez skalę odrysowania
    if (nakladka) { const c = off.getContext('2d'); c.save(); c.scale(sk, sk); nakladka(c); c.restore(); }
    canvas.width = off.width; canvas.height = off.height; canvas.getContext('2d').drawImage(off, 0, 0);
    canvas.style.width = `${v1.width * S.bazowa * S.skala}px`; canvas.style.height = `${v1.height * S.bazowa * S.skala}px`;
    S.rysowania++; uloz(false);
  }
  function uloz(odswiez = true) {
    const w = v1.width * S.bazowa * S.skala, h = v1.height * S.bazowa * S.skala;
    canvas.style.transform = `translate(${S.x}px, ${S.y}px) scale(${w / parseFloat(canvas.style.width || w)})`;
    canvas.style.transformOrigin = '0 0'; rysujEkran();
    if (odswiez) { clearTimeout(timer); timer = setTimeout(rysuj, 180); }
  }
  function zoom(f, cx, cy) {
    const n = Math.min(20, Math.max(1, S.skala * f)); const k = n / S.skala;
    S.x = cx - (cx - S.x) * k; S.y = cy - (cy - S.y) * k; S.skala = n; uloz();
  }
  // gesty
  const wsk = new Map(); let start = null, droga = 0, poczatek = null, chwyt = null;
  const naPdf = (cx, cy) => { const r = ramka.getBoundingClientRect(); const k = S.bazowa * S.skala; return [(cx - r.left - S.x) / k, (cy - r.top - S.y) / k]; };
  ramka.addEventListener('pointerdown', (e) => { if (e.target.closest('.plan-narzedzia')) return; ramka.setPointerCapture(e.pointerId); wsk.set(e.pointerId, { x: e.clientX, y: e.clientY }); start = null; droga = 0; poczatek = { x: e.clientX, y: e.clientY, n: wsk.size };
    // jeden palec na elemencie warstwy ekranu (np. róg obrysu): przeciąganie elementu; drugi palec kończy chwyt i przybliża
    chwyt = null; if (wsk.size === 1 && chwyc) { const [x, y] = naPdf(e.clientX, e.clientY); const id = chwyc(x, y, S.bazowa * S.skala); if (id != null) chwyt = { id }; }
    else if (chwyt) { pusc?.(chwyt.id); chwyt = null; } });
  ramka.addEventListener('pointerup', (e) => {
    // dotknięcie = krótki gest jednym palcem bez przesunięcia (tolerancja drgnięcia 14 px jak w makietach domu)
    // chwyt bez ruchu to zwykłe dotknięcie (rogi blisko siebie przy oddalonym planie)
    if (chwyt) { const ruszony = droga >= 4; pusc?.(chwyt.id); chwyt = null; if (ruszony) { poczatek = null; return; } }
    if (naDotkniecie && poczatek && poczatek.n === 1 && droga < 14) { const [x, y] = naPdf(e.clientX, e.clientY); naDotkniecie(x, y); }
    poczatek = null;
  });
  ramka.addEventListener('pointermove', (e) => {
    if (!wsk.has(e.pointerId)) return;
    const prev = wsk.get(e.pointerId); wsk.set(e.pointerId, { x: e.clientX, y: e.clientY });
    droga += Math.hypot(e.clientX - prev.x, e.clientY - prev.y);
    const r = ramka.getBoundingClientRect();
    if (wsk.size === 1 && chwyt) { if (droga >= 4) { const [x, y] = naPdf(e.clientX, e.clientY); przesun?.(chwyt.id, x, y); rysujEkran(); } }
    else if (wsk.size === 1) { S.x += e.clientX - prev.x; S.y += e.clientY - prev.y; uloz(); }
    else if (wsk.size === 2) {
      const [a, b] = [...wsk.values()]; const d = Math.hypot(a.x - b.x, a.y - b.y);
      if (start) zoom(d / start, (a.x + b.x) / 2 - r.left, (a.y + b.y) / 2 - r.top);
      start = d;
    }
  });
  const koniec = (e) => { wsk.delete(e.pointerId); if (wsk.size < 2) start = null; if (e.type === 'pointercancel' && chwyt) { pusc?.(chwyt.id); chwyt = null; } };
  ramka.addEventListener('pointerup', koniec); ramka.addEventListener('pointercancel', koniec);
  ramka.addEventListener('wheel', (e) => { e.preventDefault(); const r = ramka.getBoundingClientRect(); zoom(e.deltaY < 0 ? 1.15 : 1 / 1.15, e.clientX - r.left, e.clientY - r.top); }, { passive: false });
  kontener.querySelector('.plan-narzedzia').addEventListener('click', (e) => {
    const z = e.target.dataset?.z; if (!z) return; const r = ramka.getBoundingClientRect();
    if (z === '0') { dopasuj(); uloz(); } else zoom(z === '+' ? 1.5 : 1 / 1.5, r.width / 2, r.height / 2);
  });
  dopasuj(); await rysuj();
  // pokaż punkt PDF na środku ramki w danym przybliżeniu (np. punkt z listy „poza obrysami”)
  const pokaz = (x, y, skala = 4) => { const r = ramka.getBoundingClientRect(); S.skala = Math.min(20, Math.max(1, skala)); const k = S.bazowa * S.skala; S.x = r.width / 2 - x * k; S.y = r.height / 2 - y * k; uloz(); };
  return { stan: S, odswiez: () => rysuj(), odswiezEkran: rysujEkran, pokaz, naPdf, async zamknij() { clearTimeout(timer); if (zadanie) zadanie.cancel(); await doc.destroy(); } };
}

// Poprzedni indeks planu jako czerwona nakładka (porównanie A → B): ciemne linie starego planu na czerwono, białe tło przezroczyste.
// Zwraca obraz w wymiarach strony PDF (punkty), gotowy do narysowania w nakładce pokazPlan.
export async function nakladkaIndeksu(blob, { skala = 1.5 } = {}) {
  const lib = await biblioteka();
  const doc = await lib.getDocument({ data: new Uint8Array(await blob.arrayBuffer()) }).promise;
  const page = await doc.getPage(1); const v = page.getViewport({ scale: skala });
  const c = document.createElement('canvas'); c.width = Math.round(v.width); c.height = Math.round(v.height);
  const g = c.getContext('2d'); g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height);
  await page.render({ canvasContext: g, viewport: v }).promise;
  const img = g.getImageData(0, 0, c.width, c.height); const p = img.data;
  for (let i = 0; i < p.length; i += 4) { const ciemne = 255 - (p[i] * 0.3 + p[i + 1] * 0.59 + p[i + 2] * 0.11); p[i] = 215; p[i + 1] = 40; p[i + 2] = 40; p[i + 3] = Math.min(255, ciemne * 1.2); }
  g.putImageData(img, 0, 0);
  return { obraz: c, szer: v.width / skala, wys: v.height / skala };
}

// Słowa ze strony PDF w układzie strony bez obrotu (x, y = środek słowa od lewego górnego rogu, h = wysokość tekstu), jak w PyMuPDF.
// Na nich działa rozpoznanie pomieszczeń i podpisów obwodów (src/model/rozpoznanie.js, podpisy.js).
/** Ścieżki wektorowe strony (do odczytu symboli z legendy, src/model/symbole.js). */
export async function sciezkiPdf(blob, strona = 1) {
  const lib = await biblioteka(); const { sciezkiZOperatorow } = await import('./model/symbole.js');
  const doc = await lib.getDocument({ data: new Uint8Array(await blob.arrayBuffer()) }).promise;
  try {
    const page = await doc.getPage(strona); const H = page.view[3] - page.view[1];
    return { sciezki: sciezkiZOperatorow(await page.getOperatorList(), lib.OPS, H), szer: page.view[2] - page.view[0] };
  } finally { await doc.destroy(); }
}

export async function slowaPdf(blob, strona = 1) {
  const lib = await biblioteka();
  const doc = await lib.getDocument({ data: new Uint8Array(await blob.arrayBuffer()) }).promise;
  try { return await slowaStrony(await doc.getPage(strona)); } finally { await doc.destroy(); }
}

async function slowaStrony(page) {
  const H = page.view[3] - page.view[1];
  const tc = await page.getTextContent(); const out = [];
  for (const it of tc.items) {
    const s = it.str || ''; if (!s.trim()) continue;
    const [a, b, , , e, f] = it.transform; const h = Math.hypot(a, b) || it.height || 0;
    const szer = it.width || s.length * h * 0.5; const naZnak = szer / s.length;
    let i = 0; for (const t of s.split(/(\s+)/)) { if (t.trim()) out.push({ x: Math.round((e + (i + t.length / 2) * naZnak) * 10) / 10, y: Math.round((H - f - h * 0.35) * 10) / 10, h: Math.round(h * 10) / 10, t }); i += t.length; }
  }
  return out;
}

// Słowa i ścieżki z jednego otwarcia PDF (kreator „Piętro z planu”), zamiast dwóch otwarć. Wynik ostatniego planu zostaje w pamięci
// pod skrótem pliku: analiza zaczęta w tle zaraz po wgraniu planu jest gotowa (albo w toku), gdy kierownik otworzy kreator
// (14.10, plan 1.OG: kreator 4,2 s, z czego otwarcie PDF 0,5 s, słowa 0,3 s, ścieżki 1,9 s). Ścieżki bez powodzenia = null (plan bez symboli).
let ostatniaAnaliza = null;
export function analizaPlanu(blob, klucz = null, strona = 1) {
  if (klucz && ostatniaAnaliza?.klucz === klucz) return ostatniaAnaliza.wynik;
  const wynik = (async () => {
    const lib = await biblioteka(); const { sciezkiZOperatorow } = await import('./model/symbole.js');
    const doc = await lib.getDocument({ data: new Uint8Array(await blob.arrayBuffer()) }).promise;
    try {
      const page = await doc.getPage(strona); const slowa = await slowaStrony(page);
      let sciezki = null; try { sciezki = sciezkiZOperatorow(await page.getOperatorList(), lib.OPS, page.view[3] - page.view[1]); } catch { /* bez ścieżek */ }
      return { slowa, sciezki, szer: page.view[2] - page.view[0] };
    } finally { await doc.destroy(); }
  })();
  if (klucz) { ostatniaAnaliza = { klucz, wynik }; wynik.catch(() => { if (ostatniaAnaliza?.wynik === wynik) ostatniaAnaliza = null; }); }
  return wynik;
}
